import { useEffect } from 'react'
import { getSocket } from './socketManager'

interface PreAuthMethodVerifiedData {
  storeId?: string | number
  kioskId?: string | number
  storeLabel?: string
  timestamp?: string
  [key: string]: unknown
}

export const usePreAuthMethodVerifiedNotifications = (
  onPreAuthMethodVerified?: (data: PreAuthMethodVerifiedData) => void,
) => {
  useEffect(() => {
    const socket = getSocket()

    const handler = (data: PreAuthMethodVerifiedData) => {
      if (onPreAuthMethodVerified) onPreAuthMethodVerified(data)
    }

    socket.on('pre-authorization-method-verified', handler)

    return () => {
      socket.off('pre-authorization-method-verified', handler)
    }
  }, [onPreAuthMethodVerified])
}
